import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldConfigureRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-configure',
	path: '/secure/admin/ConfigureFieldScreen.jspa',
};
